
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Sites</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="projectId &amp;&amp; sites[0]?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: projectId}">{{ sites[0]?.projectName }}</a></li>
        <li class="breadcrumb-item active">Sites</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <div class="btn-group float-right dropdown" *ngIf="projectId">
          <button class="btn btn-primary dropdown-toggle" data-toggle="dropdown" type="button" [ngClass]="{'general-disabled': isMigrationActive}">Create Site</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0)" (click)="create()">Create Single Site</a><a class="dropdown-item" href="javascript:void(0)" (click)="addK2Sites()">Import Sites from K2</a><a class="dropdown-item" href="javascript:void(0)" [downloadFile]="'/api/sites/export-sites'" [params]="{projectId: projectId}">Export Site List</a><a class="dropdown-item" [uploadFileTo]="'/api/sites/import-sites?projectId=' + projectId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Upload Site List'" (closed)="uploadModalClosed($event)">Upload Site List</a></div>
        </div>
        <div class="btn-group float-right pr-1" *appSetting="'enableMultiSiteDesignFeature'">
          <div class="dropdown" *ngIf="projectId">
            <button class="btn btn-primary dropdown-toggle" data-toggle="dropdown" type="button" [ngClass]="{'general-disabled': isMigrationActive}">Multisite Design</button>
            <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0)" [downloadFile]="'/api/sites/export-multi-site-design-file'" [params]="{projectId: projectId}">Export Multisite Design</a><a class="dropdown-item" [uploadFileTo]="'/api/sites/import-multi-site-design-file?projectId=' + projectId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Multisite Design'" (closed)="uploadModalClosed($event)">Import Multisite Design</a></div>
          </div>
        </div>
      </list-controls>
    </div>
  </div>
  <div class="row" *ngIf="loading">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="card-item">
            <md-spinner-block></md-spinner-block>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col">
      <div class="row" *ngFor="let site of sites">
        <div class="col">
          <div class="card-item">
            <div class="card-progress-bar float-right">
              <div class="progress">
                <div class="progress-bar" role="progressbar" title="{{ site.deployedToK2PercentageBar.title }}" [ngClass]="site.deployedToK2PercentageBar.type" [style.width]="site.deployedToK2PercentageBar.width + '%'">{{site.deployedToK2PercentageBar.value + "%"}}</div>
              </div>
            </div>
            <h4>{{ site.name }}<span class="ml-1" *ngIf="site.city">({{site.city}}{{site.region ? ', ' : ''}}{{site.region}})</span></h4>
            <property-container>
              <property-item><a [href]="'/#/site?id=' + site.id">Details</a></property-item>
              <property-item><a [href]="'/#/workflow/' + site.workflowId">Set Up Site</a></property-item>
            </property-container>
            <property-container>
              <property-item><a [href]="'/#/orders?siteId=' + site.id">{{ site.orderCount || 0 }} order(s)</a></property-item>
              <property-item><a [href]="'/#/deployments?projectId=' + projectId + '&amp;siteId=' + site.id">{{ site.deploymentCount || 0 }} deployment(s)</a></property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="site.siteCode">Site Code: {{ site.siteCode }}</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="site.estimatedStartDate">Start Date: {{ site.estimatedStartDate | date: 'yyyy-MM-dd' : 'UTC' }}</property-item>
              <property-item [showIf]="site.estimatedCompleteDate">End Date: {{ site.estimatedCompleteDate | date: 'yyyy-MM-dd' : 'UTC' }}</property-item>
            </property-container>
            <property-container>
              <property-item>{{ site.plannedDevices }} device(s) planned</property-item>
              <property-item>{{ site.deployedDevices }} device(s) deployed</property-item>
            </property-container>
            <property-container>
              <property-item><a [href]="'/#/device-defects?siteId=' + site.id">Defective Asset Replacements</a></property-item>
              <property-item><a [href]="'/#/device-relocations?siteId=' + site.id">Reused & Relocated Assets</a></property-item>
            </property-container>
            <property-container class="red">
              <property-item [showIf]="site.pastSchedule"><span class="oi oi-clock"></span> {{ site.pastScheduleMessage }}</property-item>
            </property-container>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>